import { render, staticRenderFns } from "./PersonExperienceDetail.vue?vue&type=template&id=4b60f1f9&scoped=true&"
import script from "./PersonExperienceDetail.vue?vue&type=script&lang=js&"
export * from "./PersonExperienceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b60f1f9",
  null
  
)

export default component.exports